import React, { useContext } from "react";
import { Navigate } from "react-router-dom";
import { AuthContext } from "../../context/authContext";
import Error from "../../pages/public/Error";

const AdminRoutesHandler = ({ children }) => {
  const { user } = useContext(AuthContext);
  const role = user.role;

  return role === "Admin" || role === "Owner" ? (
    children
  ) : (
    <Error error={"UserNotAdmin"} />
  );
  // children
};

export default AdminRoutesHandler;
